import { useEnvironment } from 'yoshi-flow-editor-runtime';

export function useEnvironmentSafe() {
  try {
    return useEnvironment();
  } catch (e) {
    return { isPreview: false, isEditor: false, isViewer: false };
  }
}
